import { createAsyncThunk } from "@reduxjs/toolkit";

const API_BASE = process.env.REACT_APP_API_BASE;

/**
 * fetch all Accounts entries
 */
export const fetchAccountsItems = createAsyncThunk(
  "accounts/fetchItems",
  async () => {
    const res = await fetch(`${API_BASE}/api/accounts`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "partner",
      },
    });
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);
